var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('button',{staticClass:"primary-button"},[_vm._v("Click")]),_c('div',[_c('h1',[_vm._v("content here")])])])}]

export { render, staticRenderFns }